import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ApiHttpService {
    http = inject(HttpClient);
    public apiBaseUrl: any = environment.apiUrl;
    constructor() {
    }

    public get(url: string, options?: any) {
    return this.http.get(this.apiBaseUrl + url, options);
    }

    public post(url: string, data: any, options?: any) {
    return this.http.post(this.apiBaseUrl + url, data, options);
    }

    public put(url: string, data: any, options?: any) {
    return this.http.put(this.apiBaseUrl + url, data, options);
    }

    public delete(url: string, options?: any) {
    return this.http.delete(this.apiBaseUrl + url, options);
    }
}
